import React, { ReactNode } from 'react';

import { renderDayCell, renderEventContent } from './calendar-page-v2';
import { CalendarFeature } from '@/features/experiment/calendar';

export const CalendarPageV2 = ({
  rightActions = [],
}: {
  rightActions: ReactNode[];
}) => {
  return (
    <CalendarFeature
      rightActions={rightActions}
      renderDayCell={renderDayCell}
      renderEventContent={renderEventContent}
    />
  );
};
